import FirstStep from './FirstStep/FirstStep.component';
import SecondStep from './SecondStep/SecondStep.component';
import ThirdStep from './ThirdStep/ThirdStep.component';

export {
  FirstStep,
  SecondStep,
  ThirdStep
}